import {spacing, typography} from "material-ui/styles";
import {blue600, grey800} from "material-ui/styles/colors";

const styles = {
    drawer: {
        zIndex: 999999,
        overflow: 'unset'
    },
    logo: {
        textAlign: 'center',
        cursor: 'pointer',
        fontSize: 22,
        color: typography.textFullWhite,
        lineHeight: `${spacing.desktopKeylineIncrement}px`,
        fontWeight: typography.fontWeightLight,
        backgroundColor: blue600,
        height: 56,
    },
    menuItem: {
        color: grey800,
        fontSize: 14
    },
    langDropdown: {
        width: '100%'
    },
    menuContainer: {
        overflow: 'auto'
    },
    divider: {
        backgroundColor: grey800,
    },
    subheader: {
        color: grey800,
        fontWeight: typography.fontWeightLight,
    },
    avatar: {
        div: {
            padding: '20px 15px 15px 15px',
            backgroundColor: blue600,
            borderRadius: 0
        },
        icon: {
            verticalAlign: 'middle',
            display: 'block',
            margin: 'auto',
        },
        span: {
            overflow: 'hidden',
            textAlign: 'center',
            paddingTop: 12,
            display: 'block',
            color: 'white',
            fontWeight: typography.fontWeightLight,
            width: '100%'
        }
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/LeftDrawer/LeftDrawer.css.js